import { apiClient } from '@/shared/data/client';
import type { GlobalSearchQuery, GlobalSearchResponse } from '@flowqa/shared';

export type { GlobalSearchQuery, GlobalSearchResponse, GlobalSearchResult } from '@flowqa/shared';

export const queryGlobalSearch = async (input: GlobalSearchQuery): Promise<GlobalSearchResponse> =>
  await apiClient.post<GlobalSearchResponse>('global-search/query', input, {
    orgId: null,
  });
